import React, { useMemo, useState } from 'react';
import WordCloud from 'react-d3-cloud';

type Word = {
  text: string;
  value: number;
};

type Props = {
  words: Word[];
  onCopy: () => Promise<boolean>;
  onDownload: () => void;
};

const WordCloudComponent: React.FC<Props> = ({ words, onCopy, onDownload }) => {
  const [copied, setCopied] = useState(false);
  const MemoizedWordCloud = useMemo(() => (
    <WordCloud
      data={words}
      font="Impact"
      fontWeight="bold"
      fontSize={(word) => Math.max(12, word.value * (words.length < 10 ? 8 : 4))}
      height={Math.max(100, Math.min(500, words.length * 20))}
      padding={1}
      rotate={0}
    />
  ), [words]);

  const handleCopy = async () => {
    const success = await onCopy();
    if (!success) return;

    setCopied(true);
    window.setTimeout(() => setCopied(false), 1400);
  };

  if (words.length === 0) return null;

  return (
    // <div className="w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] px-24">
    <div className="bg-white shadow-sm rounded-lg p-6">
      <div className="flex items-center justify-between border-b pb-2 mb-4">
        <h2 className="font-bold text-gray-800">ワードクラウド</h2>
        <div className="space-x-2">
          <button
            onClick={handleCopy}
            className={`text-white px-4 py-2 rounded ${copied ? 'bg-emerald-500' : 'bg-blue-500 hover:bg-blue-600'}`}
          >
            {copied ? (
              <span className="whitespace-nowrap">コピー済み</span>
            ) : (
              <>
                <i className="fas fa-copy mr-2"></i>コピー
              </>
            )}
          </button>
          <button onClick={onDownload} className="bg-green-500 text-white px-4 py-2 rounded">
            <i className="fas fa-download mr-2"></i>保存
          </button>
        </div>
      </div>

      {/* WordCloud本体 */}
      {MemoizedWordCloud}
    </div>
  );
};

export default WordCloudComponent;
